require('./brokerHireInvestmentFundStep2.scss');

// @ vendor
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');
const { FormattedText, formatText } = require('core/i18n').i18n;
const Immutable = require('immutable');

// @ actions
const investmentFundsActions = require('actions/investmentFunds');
const brokerLegalDocumentationActions = require('actions/brokerLegalDocumentation');

// @ commons
const { OKMessage } = require('commonsComponents/OKMessage');

// @ components
const { OKConsents } = require('gdpr-consents/components/OKConsents/OKConsents.js');
const ExtantCostDetails = require('components/broker/brokerHireInvestment/brokerHireInvestmentFundStep2/components/extantCostDetails');
const { GDPRSignaturePattern } = require('components/gdprSignaturePattern/gdprSignaturePattern');
const BrokerHireInvestmentFundDetails = require('../brokerHireInvestmentFundDetails/brokerHireInvestmentFundDetails');
const { ConfirmationScript, CONFIRMATION_SCRIPT_GREETING, CONFIRMATION_SCRIPT_AGREEMENT } = require('components/contactCenter/confirmScript/confirmationScript');
const { LoadingSection } = require('commonsComponents/loadingSection');
const { BrokerFundLegalDocumentDisclaimer } = require('../../brokerFundLegalDocumentDisclaimer/brokerFundLegalDocumentDisclaimer');
const ContactCenterRender = require('components/conditionalRender/contactCenterRender');
const WebappRender = require('components/conditionalRender/webappRender');
import BrokerLegalDocumentation from 'components/broker/brokerLegalDocumentation/brokerLegalDocumentation';

// @ constants
const {
    API_ENTERPRISE_NUMBER,
    API_CENTER,
    FIRST_STEP,
    SECOND_STEP,
    THIRD_STEP,
    BROKER_GREEN_FUND,
    BROKER_YELLOW_FUND,
    BROKER_MIFID_FUND_GREEN,
    BROKER_MIFID_FUND_YELLOW,
    BROKER_MIFID_VERSION_1,
    BROKER_PRODUCT_TYPE_FUNDS,
    API_CHANNEL
} = require('constants/index');

const {
    BROKER_HIRE_INVESTMENT_FUND_ID,
    BROKER_ADD_SUBSCRIPTION_INVESTMENT_FUND_ID,
    messages: {BROKER_HIRE_INVESTMENT_FUND_AND_GDPR},
    MULTIPLE_OPERATIONS
} = require('constants/operationTypes');

const { HIRE_INITIAL_FUNDS_GDPR_PID } = require('constants/gdprPlacementIds');

// @ helpers
const { getFormattedString } = require('utilities/currencyHelper');
const { taggingEventHandled } = require('utilities/taggingEventHandled')
const { PROC_BROKER_FUNDS_PG_NAME } = require('utilities/tagging.js')
const { getPersonTypeAndCode } = require('utilities/hash');
const { getCCOfficeChannel } = require('utilities/contactCenter/printerHelper');
class BrokerHireInvestmentFundStep2 extends React.Component {
    constructor(props) {
        super(props);

        this.buildDisclaimerCheckbox = this.buildDisclaimerCheckbox.bind(this);
        this.handleReadCheckChange = this.handleReadCheckChange.bind(this);
        this.buildMifidDisclaimer = this.buildMifidDisclaimer.bind(this);
        this.buildInternationalDisclaimer = this.buildInternationalDisclaimer.bind(this);

        this.state = {
            allowClickDisclaimer: false,
            showDisclaimerErrorState: false
        }
    }

    componentDidMount() {
        const {
            history,
            immInvestmentFunds,
            fundId,
            postPreHire,
            immFlagBasedFeatures,
            immAccounts,
            extantDataFetch,
            validateEconomicReport,
            immInvestmentFundsWithContribution,
            immBrokerMyInvestments
        } = this.props;

        const isSubscription = immInvestmentFunds.getIn(['steps', 0, 'isSubscription']);
        const contractNumber = immInvestmentFunds.getIn([
            'steps',
            1,
            'contractFund',
            'contractNumber'
        ]);
        if (!isSubscription && !!!contractNumber) {
            const featureFlagShowExtantCostBuyFunds = immFlagBasedFeatures.get("wealth_funds_buy_show_costs");
            postPreHire(fundId, featureFlagShowExtantCostBuyFunds, history);
        }

        const isin = immInvestmentFunds.getIn(['investmentFunds', 'isin'])
        const amount = immInvestmentFunds.getIn(['steps', FIRST_STEP, 'amount']);
        const accountNumber = immInvestmentFunds.getIn(['steps', 0, 'accountNumber']);
        const immAccount = immAccounts.get(accountNumber);
        const currency = immAccount.getIn(['balance', 'currency']);
        const featureFlagShowExantCostBuyFunds = immFlagBasedFeatures.get("wealth_funds_buy_show_costs");
        const ffContribution = immFlagBasedFeatures.get('wealth_funds_periodic_contributions');

        const skipContribution = immInvestmentFunds.get('skipContribution');
        if (ffContribution && !isSubscription) {
            const contributionAmount = immInvestmentFundsWithContribution.getIn(['steps', 1, 'amount']);
            const recurringTransferAmount = {
                    recurringTransferAmount: {
                    amount: contributionAmount,
                    currency: currency
                },
            }
            const query = {
                importe: {
                    amount: amount,
                    currency: currency
                },
                isin: isin,
                ...(!skipContribution) && {...recurringTransferAmount}
            };
            extantDataFetch(query, history);
        } else if (
            immInvestmentFunds.get('fetchingDataExt') === false &&
            !immInvestmentFunds.get("fetchDataExtError") &&
            currency !== null &&
            isSubscription &&
            featureFlagShowExantCostBuyFunds
            ) {
                const query = {
                    importe: {
                        amount: amount,
                        currency: currency
                    },
                    isin: isin
                };
                extantDataFetch(query, history);
            }
        validateEconomicReport(history);
        taggingEventHandled(PROC_BROKER_FUNDS_PG_NAME, 'buyFundStep2', 'investmentDetails')
        taggingEventHandled(PROC_BROKER_FUNDS_PG_NAME, 'buyFundStep2', isin)
        this.props.onStepChange('step 2')
    }

    componentWillUnmount() {
        this.props.resetFetchedPre();
        this.props.removeLegalDocumentation();
        this.props.handleChangeReadChecked(false);
    }

    buildColumns() {
        const { immInvestmentFunds } = this.props;
        const isSubscription = immInvestmentFunds.getIn(['steps', FIRST_STEP, 'isSubscription']);
        if (isSubscription) {
            return [
                'brokerHireInvestmentStep2-destinationSubs',
                'account',
                'brokerHireInvestmentStep2-amountSubs',
                'brokerHireInvestmentStep2-lastValue'
            ];
        } else {
            return [
                'brokerHireInvestmentStep2-destination',
                'account',
                'brokerHireInvestmentStep2-amount'
            ];
        }
    }

    buildDetailsColumns() {
        const { immInvestmentFunds, immAccounts, immFlagBasedFeatures, immInvestmentFundsWithContribution, immBrokerMyInvestments } = this.props;
        const fundName = immInvestmentFunds.getIn(['steps', 0, 'investmentFunds', 'name']);
        const accountNumber = immInvestmentFunds.getIn(['steps', 0, 'accountNumber']);
        const immAccount = immAccounts.get(accountNumber);
        const currencyObject = Immutable.Map().merge({
            amount: immInvestmentFunds.getIn(['steps', 0, 'amount']),
            currency: immAccount?.getIn(['balance', 'currency'])
        });
        const amountInvestment = getFormattedString(currencyObject);

        let columnsContent = [fundName, 'account', amountInvestment];
        const isSubscription = immInvestmentFunds.getIn(['steps', 0, 'isSubscription']);
        if (isSubscription) {
            const liquidAmount = immInvestmentFunds.getIn(['investmentFunds', 'netAssetValue']);
            const liquidAmountText = getFormattedString(liquidAmount);
            columnsContent.push(liquidAmountText);
        }
        const columns = this.buildColumns();

        const featureFlagShowExtantCostBuyFunds = immFlagBasedFeatures.get('wealth_funds_buy_show_costs');

        if (featureFlagShowExtantCostBuyFunds) {
            return (
                <ExtantCostDetails
                    immInvestmentFunds={immInvestmentFunds}
                    immAccount={immAccount}
                    immFlagBasedFeatures={immFlagBasedFeatures}
                    immInvestmentFundsWithContribution={immInvestmentFundsWithContribution}
                    immBrokerMyInvestments={immBrokerMyInvestments}
                />
            )
        } else {
            return (
                <BrokerHireInvestmentFundDetails
                    columns={columns}
                    columnsContent={columnsContent}
                    immAccount={immAccount}
                    immInvestmentFunds={immInvestmentFunds}
                    immFlagBasedFeatures={immFlagBasedFeatures}
                />
            );
        }
    }

    buildDisclaimerCheckbox() {
        const { immInvestmentFunds, immFlagBasedFeatures } = this.props;
        const { showDisclaimerErrorState } = this.state

        const showDetailsCost = immFlagBasedFeatures.get("wealth_funds_buy_show_costs");

        const fundName = immInvestmentFunds.getIn(['steps', FIRST_STEP, 'investmentFunds', 'name']);
        const fundIsin = immInvestmentFunds.getIn(['steps', FIRST_STEP, 'investmentFunds', 'isin']);
        const fundSecId = immInvestmentFunds.getIn([
            'steps',
            FIRST_STEP,
            'investmentFunds',
            'secId'
        ]);
        const isSpanish = (fundIsin + '').slice(0, 2).toLowerCase() === 'es';
        const checked = immFlagBasedFeatures.get('wealth_funds_periodic_contributions')
            ? immInvestmentFunds.getIn(['steps', THIRD_STEP, 'readChecked'])
            : immInvestmentFunds.getIn(['steps', SECOND_STEP, 'readChecked']);

        return (
            <div className="hire-investment-step2__declaration-text">
                <BrokerFundLegalDocumentDisclaimer
                    disclaimerErrorState={showDisclaimerErrorState}
                    disclaimerErrorMessage={formatText('brokerHireInvestmentStep2-checkError')}
                    disclaimerChecked={checked}
                    onDisclaimerCheckChange={this.handleReadCheckChange}
                    isSpanish={isSpanish}
                    fundName={fundName}
                    fundIsin={fundIsin}
                    fundSecId={fundSecId}
                    enableTransactionCost={!showDetailsCost}
                />
            </div>
        );
    }

    buildInfoSubs() {
        const { immInvestmentFunds } = this.props;
        const isSubscription = immInvestmentFunds.getIn(['steps', 0, 'isSubscription']);
        if (isSubscription) {
            return (
                <OKMessage type="informative">
                    <FormattedText value="brokerHireInvestmentStep2-info" />
                </OKMessage>
            );
        }
    }

    buildInternationalDisclaimer() {
        const { immInvestmentFunds } = this.props;
        const isSubscription = immInvestmentFunds.getIn(['steps', FIRST_STEP, 'isSubscription']);
        const fundIsin = immInvestmentFunds.getIn(['steps', FIRST_STEP, 'investmentFunds', 'isin']);
        const isSpanish = (fundIsin + '').slice(0, 2).toLowerCase() === 'es';
        if (!isSpanish && !isSubscription) {
            const title = (
                <FormattedText value="fundLegalDocumentDisclaimer-internationalManagerTitle" />
            );
            const paragraph1 = (
                <FormattedText value="fundLegalDocumentDisclaimer-internationalManagerParagraph1" />
            );
            const paragraph2 = (
                <FormattedText value="fundLegalDocumentDisclaimer-internationalManagerParagraph2" />
            );
            const paragraph3 = (
                <FormattedText value="fundLegalDocumentDisclaimer-internationalManagerParagraph3" />
            );

            return (
                <div className="hire-investment-step2__international-disclaimer">
                    <OKMessage type="informative">
                        <p>
                            <b>
                                {title}
                            </b>
                        </p>
                        <p>
                            {paragraph1}
                        </p>
                        <p>
                            {paragraph2}
                        </p>
                        <p>
                            {paragraph3}
                        </p>
                    </OKMessage>
                </div>
            );
        }
    }

    buildMifidDisclaimer() {
        const { immBrokerConvenienceMiFIDTest, immBrokerMiFIDProducts, immInvestmentFunds } = this.props;
        const usingMifidv1 = immBrokerConvenienceMiFIDTest.get('mifidVersion') === BROKER_MIFID_VERSION_1;

        if (usingMifidv1) {
            const fundType = immInvestmentFunds.getIn([
                'steps',
                FIRST_STEP,
                'investmentFunds',
                'customCategoryId3'
            ]);

            if (fundType === BROKER_YELLOW_FUND || fundType === BROKER_GREEN_FUND) {
                const fundMifidId =
                    fundType === BROKER_YELLOW_FUND
                        ? BROKER_MIFID_FUND_YELLOW
                        : BROKER_MIFID_FUND_GREEN;

                if (immBrokerMiFIDProducts.getIn(['products', fundMifidId, 'loading'])) {
                    return <LoadingSection />;
                } else {
                    const mifidDisclaimer = immBrokerMiFIDProducts.getIn([
                        'products',
                        fundMifidId,
                        'disclaimer'
                    ]);

                    return (
                        <div className="hire-investment-step2__mifid-disclaimer">
                            <OKMessage type="informative">
                                {mifidDisclaimer}
                            </OKMessage>
                        </div>
                    );
                }
            }
        }
    }

    handleReadCheckChange(ev) {
        const { handleChangeReadChecked, immLegalDocumentationProduct, immInvestmentFunds } = this.props
        let documentsForRead=0;
        const fundIsin = immInvestmentFunds.getIn(['steps', FIRST_STEP, 'investmentFunds', 'isin']);
        const listDocuments = immLegalDocumentationProduct.getIn(['boxes',fundIsin, 'documents'])
        if (!!listDocuments) {
            listDocuments.map((doc) => {
                const immDoc = doc.toJS();
                immDoc.read === false && documentsForRead++;

            })
        }

        const { allowClickDisclaimer } = this.state
        if(allowClickDisclaimer && documentsForRead === 0) {
            this.setState({ showDisclaimerErrorState: false })
            handleChangeReadChecked(ev.target.checked)
        }else {
            this.setState({ showDisclaimerErrorState: true })
        }
    }

    renderDocumentationBox = () => {
        const { immInvestmentFunds, immFlagBasedFeatures } = this.props;
        if (immInvestmentFunds.get('fetchingDocumentsValidate')) {
            return null;
        }

        const showDetailsCost = immFlagBasedFeatures.get("wealth_funds_buy_show_costs");

        const fundName = immInvestmentFunds.getIn(['steps', FIRST_STEP, 'investmentFunds', 'name']);
        const fundIsin = immInvestmentFunds.getIn(['steps', FIRST_STEP, 'investmentFunds', 'isin']);
        const fundSecId = immInvestmentFunds.getIn([
            'steps',
            FIRST_STEP,
            'investmentFunds',
            'secId'
        ]);
        const enableEconomicReport = immInvestmentFunds.get('enableEconomicReport');

        return (
            <BrokerLegalDocumentation
                className="hire-investment-step2__documentation-box"
                isin={fundIsin}
                secId={fundSecId}
                productDefinition={fundName}
                productType={BROKER_PRODUCT_TYPE_FUNDS}
                reportCompleted={() => this.setState({ allowClickDisclaimer: true })}
                enableTransactionCost={!showDetailsCost}
                pageName={PROC_BROKER_FUNDS_PG_NAME}
                enableEconomicReport={enableEconomicReport}
            />
        );
    }

    render() {
        const { immInvestmentFunds, immAccounts, immFlagBasedFeatures, immInvestmentFundsWithContribution, immBrokerMyInvestments } = this.props;
        const { showDisclaimerErrorState } = this.state
        const ffContribution = immFlagBasedFeatures.get('wealth_funds_periodic_contributions');
        const isSubscription = immInvestmentFunds.getIn(['steps', 0 ,'isSubscription'], false);
        const showGDPRSignaturePattern = __CONTACT_CENTER__
            ? true
            : ffContribution && !isSubscription
                ? immInvestmentFunds.getIn(['steps', THIRD_STEP, 'readChecked'])
                : immInvestmentFunds.getIn(['steps', SECOND_STEP, 'readChecked']);
        const featureFlagShowExtantCostBuyFunds = immFlagBasedFeatures.get("wealth_funds_buy_show_costs");
        const accountNumber = immInvestmentFunds.getIn(['steps', 0, 'accountNumber']);
        const skipContribution = immInvestmentFundsWithContribution.get('skipContribution');
        const immAccount = immAccounts.get(accountNumber);
        const columnsContainer = this.buildDetailsColumns();
        const mifidDisclaimer = this.buildMifidDisclaimer();
        const infoLabel = this.buildInfoSubs();
        const internationalDisclaimer = this.buildInternationalDisclaimer();
        let operationParams;
        let trxId = isSubscription
            ? BROKER_ADD_SUBSCRIPTION_INVESTMENT_FUND_ID
            : BROKER_HIRE_INVESTMENT_FUND_ID;
        const productNumber = immInvestmentFunds.getIn(['contractFund', 'product']);
        const contractNumber = immInvestmentFunds.getIn(['contractFund', 'contractNumber']);
        let operative;
        const consentElement = (<OKConsents placementId={HIRE_INITIAL_FUNDS_GDPR_PID} />);

        const currencyObject = {
            amount: immInvestmentFunds.getIn(['steps', 0, 'amount']),
            currency: immAccount.getIn(['balance', 'currency'])
        };


        if (isSubscription) {
            operative = formatText('operatives-buyInvestmentFund');
            operationParams = {
                originAccount: `${API_ENTERPRISE_NUMBER}${API_CENTER}${productNumber}${contractNumber}`,
                ammount: parseFloat(currencyObject.amount),
                currency: currencyObject.currency
            };
        } else {
            operative =  formatText('operatives-contractInevestmentFund');
            operationParams = {
                originAccount: `${API_ENTERPRISE_NUMBER}${API_CENTER}${productNumber}${contractNumber}`
            };
        }

        if(ffContribution && !skipContribution && !isSubscription) {
            const userData = getPersonTypeAndCode();
            const idUser = userData.f;
            const documentTypeUser = userData.type;
            trxId = MULTIPLE_OPERATIONS;
            const otherData = {
                channel: __CONTACT_CENTER__ ? getCCOfficeChannel() : API_CHANNEL,
                clientId: `${idUser}`,
                clientType: documentTypeUser,
            }

            const params = {
                serviceCode: 71,
                ...operationParams,
                ...otherData
            }

            operationParams =  [
                    {
                        ...params,
                    },
                    {
                        serviceCode: 202,
                        ammount: `+${immInvestmentFundsWithContribution.getIn(['steps', 1, 'amount'])}`,
                        ...otherData,
                        currency: immAccount.getIn(['balance', 'currency']),
                        originAccount: `${API_ENTERPRISE_NUMBER}${API_CENTER}${productNumber}${contractNumber}`
                    },
                ]

        }

        if (!isSubscription && !immInvestmentFunds.get('isFetchedPre') ||
            immInvestmentFunds.get('fetchingDocumentsValidate') ||
            immInvestmentFunds.get('fetchingEconomicReportValidation')) {
            return <LoadingSection />
        } else if (isSubscription && immInvestmentFunds.get('isFetchingPre')) {
            return <LoadingSection />
        } else if (isSubscription && immInvestmentFunds.get('fetchingDataExt')) {
            return <LoadingSection />
        } else {
            return (
                <div className="hire-investment-step2">
                    <header className="hire-investment-step2__header">
                        <h2 className="hire-investment-step2__title">
                            <FormattedText
                                value="brokerHireInvestmentStep2-title"
                                className="hire-investment-step2_description"
                            />
                        </h2>
                    </header>
                    <ContactCenterRender>
                        <ConfirmationScript operative={operative} confirmationType={CONFIRMATION_SCRIPT_GREETING} />
                    </ContactCenterRender>
                    {!featureFlagShowExtantCostBuyFunds &&
                        <FormattedText
                            value="brokerHireInvestmentStep2-description"
                            className="hire-investment-step2__description"
                        />
                    }
                    {columnsContainer}
                    {consentElement}
                    {mifidDisclaimer}
                    <WebappRender>
                        <div className="row">
                            <div className="col-sm-12 hire-investment-step2__documentationbox">
                                {this.renderDocumentationBox()}
                            </div>
                        </div>
                    </WebappRender>
                    {infoLabel}
                    {internationalDisclaimer}
                    <WebappRender>
                        <div className="hire-investment-step2__checkbox">
                            <div className="hire-investment-step2__checkbox__message">
                                {showDisclaimerErrorState &&
                                    <OKMessage type="warning">
                                        <FormattedText value="brokerLegalDocumentation-documentsRead" />
                                    </OKMessage>
                                }
                            </div>
                            {this.buildDisclaimerCheckbox()}
                        </div>
                    </WebappRender>
                    <ContactCenterRender>
                        <ConfirmationScript confirmationType={CONFIRMATION_SCRIPT_AGREEMENT} />
                    </ContactCenterRender>
                    {showGDPRSignaturePattern &&
                        <div className="hire-investment-step2__signature-container">
                            <GDPRSignaturePattern
                                operationType={trxId}
                                operationParams={operationParams}
                                multiOTPMessageCode={BROKER_HIRE_INVESTMENT_FUND_AND_GDPR}
                                isWealth={true}
                            />
                        </div>
                    }
                </div>
            );
        }
    }
}

BrokerHireInvestmentFundStep2.defaultProps = {
    owner: ''
};

BrokerHireInvestmentFundStep2.propTypes = {
    fundId: PropTypes.string.isRequired,
    handleChangeAuth: PropTypes.func.isRequired,
    validateEconomicReport: PropTypes.func.isRequired,
    handleChangeReadChecked: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    immInvestmentFunds: PropTypes.object.isRequired,
    immBrokerMyInvestments: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immBrokerConvenienceMiFIDTest: PropTypes.object.isRequired,
    immBrokerMiFIDProducts: PropTypes.object.isRequired,
    postPreHire: PropTypes.func.isRequired,
    resetFetchedPre: PropTypes.func.isRequired,
    removeLegalDocumentation: PropTypes.func.isRequired,
    immFlagBasedFeatures: PropTypes.object,
    extantDataFetch: PropTypes.func,
    onStepChange: PropTypes.func,
    validateFundDocuments: PropTypes.func
};

module.exports.constructor = BrokerHireInvestmentFundStep2;
module.exports.BrokerHireInvestmentFundStep2 = connect(
    state => ({
        immBrokerConvenienceMiFIDTest: state.brokerConvenienceMiFIDTest,
        immBrokerMiFIDProducts: state.brokerMiFIDProducts,
        immInvestmentFundsWithContribution: state.investmentFundsWithContribution,
        immLegalDocumentationProduct: state.brokerLegalDocumentation,
    }),
    {
        handleChangeAuth: investmentFundsActions.changeAuth,
        handleChangeReadChecked: investmentFundsActions.changeReadChecked,
        hireInvestment: investmentFundsActions.hireInvestment,
        postPreHire: investmentFundsActions.postPreHire,
        resetFetchedPre: investmentFundsActions.resetFetchedPre,
        validateEconomicReport: investmentFundsActions.validateEconomicReport,
        removeLegalDocumentation: brokerLegalDocumentationActions.removeLegalDocumentation,
        extantDataFetch: investmentFundsActions.postExtantCostsBuyFunds,
        validateFundDocuments: investmentFundsActions.validateFundDocuments,
    }
)(withRouter(BrokerHireInvestmentFundStep2));
